import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-guide')!;

export default function ArticleGuidePage() {
  return <ArticleTemplate article={article} />;
}